import { useEffect, useRef } from 'react';

import cn from 'classnames/bind';
import { useAsyncRequest } from 'hooks';
import { ErrorMessage, Spinner } from 'ui';

import styles from './GetData.module.scss';

const cx = cn.bind(styles);

const GetData = ({
  children, Loader, Error, fn, initialIsLoading = false, isSingleView = false,
}) => {
  const isDataFetchedRef = useRef(false);
  const {
    errorMessage, error, isLoading, data, invoke,
  } = useAsyncRequest({ initialIsLoading });
  useEffect(() => {
    if (!isDataFetchedRef.current && fn) {
      isDataFetchedRef.current = true;
      invoke(fn);
    }
  }, [fn, invoke]);

  const loaderComponent = Loader ? <Loader /> : <Spinner />;
  let errorComponent = null;
  if (errorMessage) {
    errorComponent = Error ? <Error text={errorMessage}/> : <ErrorMessage text={errorMessage} />;
  }
  const getDataComponent = () => (typeof children === 'function' ? children({ isLoading, error, data }) : children);

  return (<>
    { isLoading && !isSingleView && <div className={cx('loader')}>{loaderComponent}</div>}
    { !isSingleView && errorComponent }
    { (isSingleView || data) ? getDataComponent() : null }
  </>);
};

export default GetData;
